module.exports = {
  space: '&nbsp;',

  /** Enables use of <SCRIPT type="syntaxhighlighter" /> tags. */
  useScriptTags: true,

  /** Blogger mode flag. */
  bloggerMode: false,

  stripBrs: false,

  /** Name of the tag that SyntaxHighlighter will automatically look for. */
  tagName: 'pre'
};



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/